import { render, staticRenderFns } from "./ConfirmLicenseForPlanPurchasing.vue?vue&type=template&id=74165cad&scoped=true"
import script from "./ConfirmLicenseForPlanPurchasing.vue?vue&type=script&lang=js"
export * from "./ConfirmLicenseForPlanPurchasing.vue?vue&type=script&lang=js"
import style0 from "./ConfirmLicenseForPlanPurchasing.vue?vue&type=style&index=0&id=74165cad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74165cad",
  null
  
)

export default component.exports